import {FC} from 'react'
import moment from "moment/moment";

type Props = {
  data: string
}

const UserTwoStepsCell: FC<Props> = ({data}) => (
  <> {data && <div className='fw-bolder'>{moment(data).format('YYYY-MM-DD HH:mm')}</div>}</>
)

export {UserTwoStepsCell}
